import { Component, OnInit } from "@angular/core";
import {IndexNavbarComponent} from '../../navbars/index-navbar/index-navbar.component'

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
})
export class FooterComponent implements OnInit {

  date = new Date().getFullYear();
  constructor() {}

  ngOnInit(): void {}
 
}
